import React from "react";

import { useTranslation } from "utils";

import { Button, Icon } from "components";

import { SectionHeading } from "pages/app/scenario-analysis/components/SectionHeading";

export interface EconomicsSectionProps {
  onEditEconomicInputs: () => void;
}

/** Full-width section under the chart: heading left, the edit action right. */
export const EconomicsSection = ({ onEditEconomicInputs }: EconomicsSectionProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <section className="economics-section" data-testid="economics-section">
      <SectionHeading
        title={t("aboutYourField.economics.title")}
        supporting={t("aboutYourField.economics.supporting")}
        dataTestId="economics-section-heading"
        control={
          <Button
            type="primary"
            size="middle"
            onClick={onEditEconomicInputs}
            icon={<Icon iconName="tabler/arrow-narrow-right" size="m" color="white" />}
            className="economics-section-cta"
            mixpanelText="Edit economic inputs"
            dataTestId="economics-section-cta"
          >
            {t("aboutYourField.economics.cta")}
          </Button>
        }
      />
    </section>
  );
};

export default EconomicsSection;
